'use strict';

require('./util/webpackSetup');

var base = require('./product/base');

/**
 * Perform operation when the user clicks on gift card check balance button.
 *
 */
function checkGiftCardBalance() {
    $('form[name=balance-check-form]').submit(function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (data.balance) {
                    $('form[name=balance-check-form]').find('input.form-control').removeClass('is-invalid');
                    $('form[name=balance-check-form]').find('.invalid-feedback')
                        .text('');
                    $('#giftcard-checkbalance-btn').hide();
                    $('#giftcard-balance-container').removeClass('d-none');
                    $('#giftcard-balance').text(data.balance);
                } else {
                    $('form[name=balance-check-form]').find('input.form-control').addClass('is-invalid');
                    $('form[name=balance-check-form]').find('.invalid-feedback')
                        .text(data.errorMessage);
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                form.spinner().stop();
            }
        });
        return false;
    });
}

/**
 * Perform operation when the user clicks on add gift card to cart button.
 *
 */
function giftCardAddToCart() {
    $('form[name=physical-card-form], form[name=egift-card-form]').submit(function (e) {
        var errElement = $('#form-error-message');
        if (errElement) {
            errElement.remove();
        }
        var isEgiftForm = this.id === 'egift-card-form';
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        if (window.utag_data) {
            if (isEgiftForm) {
                var egiftObj = {
                    event_type: 'cart_add_egift_card',
                    ga_action: 'Add to Cart | EGiftcard',
                    pid: $('form[name=egift-card-form] select[id=amount]').val()
                };
                $(document).trigger('giftcard:addgiftcard', egiftObj);
            } else {
                var physicalgiftObj = {
                    event_type: 'cart_add_physical_gift_card',
                    ga_action: 'Add to Cart | Physical Giftcard',
                    pid: $('form[name=physical-card-form] select[id=amount]').val(),
                    quantity: [$('form[name=physical-card-form] select[id=quantity]').val()]
                };
                $(document).trigger('giftcard:addgiftcard', physicalgiftObj);
            }
        }
        form.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                if (!data.result.error) {
                    form.spinner().stop();
                    var res = data;
                    res.minicartSuccessMsg = data.result.message;
                    base.handlePostCartAdd(res);
                    $('body').trigger('product:afterAddToCart', data); // This will set updateMiniCart flag true in miniCart.js
                    if (isEgiftForm) {
                        form.trigger('reset');
                    }
                    $('select').each(function () { this.selectedIndex = 0; });
                } else {
                    form.spinner().stop();
                    var errorMessage = '';
                    if (data.result.gcOrderFormErrors) {
                        $.each(data.result.gcOrderFormErrors, function (key, value) {
                            errorMessage += value + '<br />';
                        });
                    } else {
                        errorMessage += data.result.errorMessage;
                    }
                    form.prepend('<div id="form-error-message" class="alert alert-danger" role="alert">' + errorMessage + '</div>');
                }
            },
            error: function (err) {
                form.spinner().stop();
                throw err;
            }
        });
        return false;
    });
}

/**
 * Perform operation when the user clicks on gift card check balance button.
 *
 */
function hideGiftCardBalance() {
    $('#giftcard-checkbalance-btn').show();
    $('#giftcard-balance-container').addClass('d-none');
    $('#giftcard-balance').text('');
    $('form[name=balance-check-form]').trigger('reset');
}

/**
 * Perform operation when the user clicks on gift card check balance button.
 *
 */
function setEmailCustomValidation() {
    var mailEl = $('#egift-form-rec-email');
    var confirmMailEl = $('#egift-form-conf-rec-email');
    if (mailEl.val() !== confirmMailEl.val()) {
        var errText = confirmMailEl.data('email-mismatch');
        mailEl[0].setCustomValidity(errText);
        confirmMailEl[0].setCustomValidity(errText);
    } else {
        mailEl[0].setCustomValidity('');
        confirmMailEl[0].setCustomValidity('');
    }
}

$(document).ready(function () {
    $(document).on('click', '#gift-terms-and-condition', function () {
        $('#unique-id-giftcard-tnc').modal('show');
    });
    $(document).on('click', '#check-balance-btn', function () {
        $('#unique-id-giftcard-balance-check').modal('show');
        if (window.utag_data) {
            $(document).trigger('giftcard:checkbalance');
        }
    });
    checkGiftCardBalance();
    giftCardAddToCart();
    $(document).on('click', '#giftcard-balance-container-close', function () {
        hideGiftCardBalance();
    });
    $(document).on('blur', '#egift-form-conf-rec-email, #egift-form-rec-email', function () {
        setEmailCustomValidation();
    });
});
